<template>
  <div class="relative" v-if="aboutcampaignBanner.result.length">
    <!-- src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg" -->
    <img
      :src="
        $imageURL + '/' + aboutcampaignBanner.result[0].image ||
        'https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg'
      "
      alt="img"
      class="w-full lg:h-96 md:h-96 h-72 h-450px filter-b7 sm-h-250px object-cover"
    />
    <div
      class="lg:w-1/2 md:w-1/2 w-11/12 absolute bottom-6 lg:left-10 md:left-10 left-5"
    >
      <p class="font-semibold fsize24 sm-fsize20 pb-2 text-white sm-lh25px">
        {{ aboutcampaignBanner.result[0].heading }}
      </p>
      <p class="sm-fsize16 fsize18 text-white sm-lh20">
        {{ aboutcampaignBanner.result[0].subheading }}
      </p>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("campaignPageBanner", {
      aboutcampaignBanner: "aboutcampaignBanner",
    }),
  },

  methods: {},
  async mounted() {
    await this.$store.dispatch("campaignPageBanner/get_aboutcampaignsbanner");
    console.log("aboutcampaignBanner", this.aboutcampaignBanner);
    // console.log("campaignHome length:", this.campaignHome.result.length);
  },
};
</script>
